import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function useTitle(key, values) {
  const { t } = useTranslation()
  useEffect(() => {
    const env =
      window.location.hostname === 'localhost'
        ? ' (local)'
        : t('environmentQualifier', ' ')

    document.title = t(key, values) + env
  }, [key, values])
}
